import { Skeleton, Stack } from '@mui/material';

export default function LeadTimesSkeletons() {
	return (
		<Stack margin={2} spacing={4} height={'100%'}>
			<Stack direction="column" spacing={1.5}>
				<Skeleton
					variant="rectangular"
					width={235}
					height={40}
					sx={{
						borderRadius: '5px',
					}}
				/>
				<Skeleton
					variant="rectangular"
					width={500}
					height={30}
					sx={{
						borderRadius: '5px',
					}}
				/>
			</Stack>
			<Skeleton
				variant="rectangular"
				height={400}
				sx={{
					borderRadius: '5px',
				}}
			/>
		</Stack>
	);
}
